export default {
  whoWeAre: "Who We Are",
  whoWeAreDescription: "A leading pharmaceutical platform with 40+ years of API excellence, global partnerships in advanced intermediates, and CRDMO expertise in speciality formulations and antibiotics.",
  globalImpactExcellence: "Global Impact & Excellence",
  globalImpactDescription: "Trusted by partners worldwide for delivering meaningful innovations through science.",
  whatWeOffer: "What We Offer",
  whatWeOfferDescription: "Comprehensive pharmaceutical solutions backed by decades of expertise and global reach, delivering innovation from lab to life across diverse therapeutic areas.",
  regulatoryApprovals: "Regulatory Approvals",
  regulatoryApprovalsDescription: "Refex Life Sciences operates a worldwide network of state-of-the-art manufacturing facilities seamlessly integrated into the group. These facilities comply with the highest international quality standards with accreditations from:",
  regulatoryApproval1: "US FDA",
  regulatoryApproval2: "EU GMP",
  regulatoryApproval3: "EDQM",
  regulatoryApproval4: "Health Canada",
  regulatoryApproval5: "ANVISA",
  regulatoryApproval6: "PMDA",
  regulatoryApproval7: "WHO-GMP",
  noOfferingsAvailable: "No offerings available. Please add some in the admin panel.",
};

